import {Component, OnInit} from '@angular/core';
import { MenuUtil } from "../utils/menu-utils";


@Component({
    selector: 'app-breadcrumb',
    templateUrl: './app.breadcrumb.component.html',
    styleUrls: ['./app.breadcrumb.component.scss']
})
export class AppBreadcrumbComponent implements OnInit {

  readonly breadcrumbs$ = MenuUtil._breadcrumbs$.asObservable();

  ngOnInit(): void {
    MenuUtil.localStorageChanges.subscribe({
      next: () => {
        MenuUtil.initBreadcrumb();
      }
    });
  }
}
